import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/carRentExtraServices', request)
}

async function post(request) {
    return await postMethod('/api/carRentExtraServices', request)
}

async function put(request) {
    return await putMethod('/api/carRentExtraServices', request)
}

export {get, post, put}
